import { ASSET_RESET_ICON_PATH } from '@/consts/imgPath';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  totalBalance: string;
  trxAddress: string;
  isSendingAsset: boolean;
  dbsBuyCount: string;
  dbsBuyCountKRW: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickResetBtn: () => void;
  onClickSendBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
}
// (event: React.MouseEvent<HTMLAnchorElement>) => void;
const MyAssetsCard = ({
  totalBalance,
  trxAddress,
  isSendingAsset,
  dbsBuyCount,
  dbsBuyCountKRW,
  onClickCopyBtn,
  onClickResetBtn,
  onClickSendBtn,
  onClickViewType,
}: IProps): JSX.Element => {
  const handleClickCopyBtn = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onClickCopyBtn(e as unknown as React.MouseEvent<HTMLButtonElement>);
    },
    [onClickCopyBtn],
  );

  return (
    <div className="card-ui" style={{ paddingTop: '12px', paddingBottom: '15px' }}>
      <div className="icon card_title_row" style={{ marginTop: '0px' }}>
        <img className="card_icon" src="img/BI_Circle.png" style={{ width: '65px' }} alt="Icon" />
        <h2 className="card_title" style={{ fontSize: '200%' }}>
          자산정보
        </h2>
        <a href="#" className="right" style={{ marginLeft: '1rem' }} onClick={onClickResetBtn}>
          <img className="card_reset_icon" src={ASSET_RESET_ICON_PATH} style={{ width: '45%' }} alt="reset-icon" />
        </a>
      </div>
      <div className="total-amount" style={{ marginTop: '5px' }}>
        <div className="asset-info">
          <div
            className="asset-row card_text_size card_row"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '75px',
              fontSize: '1.25rem',
              marginBottom: '-0.3rem',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
              <img
                className="card_row_icon"
                src="img/card_item.png"
                style={{ width: '15px', height: '15px', marginRight: '1rem' }}
                alt=""
              />
              <span className="card_txt" style={{ marginRight: '1rem', fontWeight: 'bold', fontSize: '130%' }}>
                총 보유자산
              </span>
            </div>
            <span className="card_txt" style={{ fontSize: '140%', fontWeight: 'bold' }}>
              {totalBalance} KRW
            </span>
          </div>
          <div
            className="asset-row card_text_size card_row"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '75px',
              fontSize: '1.25rem',
              marginBottom: '-0.3rem',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
              <img
                className="card_row_icon"
                src="img/card_item.png"
                style={{ width: '15px', height: '15px', marginRight: '1rem' }}
                alt=""
              />
              <span className="card_txt" style={{ marginRight: '1rem', fontWeight: 'bold', fontSize: '130%' }}>
                구매수량
              </span>
            </div>
            <span className="card_txt" style={{ fontSize: '140%', fontWeight: 'bold' }}>
              <span>{dbsBuyCount}</span> <span className="card_dbs_leter card_dbs_letter">DBS</span>
            </span>
          </div>
          <div
            className="asset-row card_text_size card_row"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '75px',
              fontSize: '1.25rem',
              marginBottom: '-0.3rem',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
              <img
                className="card_row_icon"
                src="img/card_item.png"
                style={{ width: '15px', height: '15px', marginRight: '1rem' }}
                alt=""
              />
              <span className="card_txt" style={{ marginRight: '1rem', fontWeight: 'bold', fontSize: '130%' }}>
                구매금액
              </span>
            </div>
            <span className="card_txt" style={{ fontSize: '140%', fontWeight: 'bold' }}>
              {dbsBuyCountKRW} KRW
            </span>
          </div>
        </div>
      </div>
      <div className="address body-xs text-ellipsis card_address">
        {trxAddress}
        <a href="#" onClick={handleClickCopyBtn}>
          <div className="img card_copy_icon">
            <img src="img/copy-icon.png" alt="copy-icon" />
          </div>
        </a>
      </div>
      <div className="button-group card_btn_group" style={{ paddingBottom: ' 13px', fontWeight: 'bold' }}>
        <button
          className={clsx('solid', { disabled_btn: !isSendingAsset })}
          disabled={!isSendingAsset}
          onClick={onClickSendBtn}
        >
          보내기
        </button>
        <button className="solid" onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}>
          받기
        </button>
      </div>
    </div>
  );
};

export default MyAssetsCard;
